import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/renderprops-addons.cjs'

// Components
import Layout from '../components/Layout'
import ProjectCard from '../components/ProjectCard'

// Elements
import Inner from '../elements/Inner'
import { Title, BigTitle, Subtitle } from '../elements/Titles'

// Views
import Hero from '../views/Hero'
import Projects from '../views/Projects'
import About from '../views/About'
import Contact from '../views/Contact'

import avatar from '../images/avatar.jpg'

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`

const Avatar = styled.img`
  ${tw`rounded-full w-32 xl:w-48 shadow-lg h-auto`};
`

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`

const AboutDesc = styled.p`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`

const ContactText = styled.p`
  ${tw`text-grey-light font-sans text-xl md:text-2xl lg:text-3xl`};
`

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 font-sans text-md lg:text-lg`};
`

const Index = () => (
  <>
    <Layout />
    <Parallax pages={5}>
      <Hero offset={0}>
        <BigTitle>
          Hello, <br /> I'm Amin Mushehid.
        </BigTitle>
        <Subtitle>I'm an aspiring fullstack developer, currently looking for an internship at an interesting company.</Subtitle>
      </Hero>
      <Projects offset={1}>
        <Title>Projects</Title>
        <ProjectsWrapper>
          <ProjectCard
            title="Todo App"
            link="http://todo.aminmushehid.chas.academy/"
            bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)"
          >
            Todo App with a PHP and MySQL back-end.
          </ProjectCard>
          <ProjectCard
            title="IMDB Clone"
            link="http://imdbdragons.rubensalasamner.chas.academy/"
            bg="linear-gradient(to right, #2E1437 0%, #948E99 100%)"
          >
            An IMDB-inspired site made with Laravel and MySQL (Group Project).
          </ProjectCard>
          <ProjectCard
            title="Meditation App"
            link="https://moment23.amin.nu/"
            bg="linear-gradient(to right, #001510 0%, #00BF8F 100%)"
          >
            Meditation App made with React, Node.js and MongoDB (work in progress).
          </ProjectCard>
          <ProjectCard
            title="Kanban Board"
            link="http://aminmushehid.chas.academy/kanban/"
            bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
          >
            A Trello-inspired Kanban Board made with jQuery and jQuery UI.
          </ProjectCard>
          <ProjectCard
            title="Photo Search"
            link="http://aminmushehid.chas.academy/api-mashup/"
            bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)"
          >
            Search and browse photos from Flickr.
          </ProjectCard>
          <ProjectCard
            title="Hangman"
            link="http://aminmushehid.chas.academy/hangman/"
            bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)"
          >
            A simple Hangman game, created with Vanilla JS.
          </ProjectCard>
        </ProjectsWrapper>
      </Projects>
      <About offset={3}>
        <Title>About</Title>
        <AboutHero>
          <Avatar src={avatar} alt="Amin Mushehid" />
          <AboutSub>
            I'm a student at Chas Academy, learning all about web development.
          </AboutSub>
        </AboutHero>
        <AboutDesc>
          I never saw myself as a particularly creative person, but that all changed when I started programming. Coming up with solutions to real life problems through code is something I truly love, because it allows me to make use of my inner creativity to achieve directly visible results.
        <br />
          <br />
          Some of the technologies I'm currently using and learning about are JavaScript, React, Angular, Node JS, PHP, Laravel and MySQL.
        </AboutDesc>
      </About>
      <Contact offset={4}>
        <Inner>
          <Title>Get in touch</Title>
          <ContactText>
            Say <a href="mailto:amin.mushehid@gmail.com">Hi</a> or find me on other platforms:{' '}
            <a href="https://www.linkedin.com/in/amin-mushehid/">LinkedIn</a> &{' '}
            <a href="https://github.com/aminmus/">Github</a>
          </ContactText>
        </Inner>
        <Footer>

          <a href="https://github.com/aminmus/">&copy; 2019 Amin Mushehid{' '}</a>
        </Footer>
      </Contact>
    </Parallax>
  </>
)

export default Index
